import apiFetch from '../apiFetch'

export default function (token, presentId) {
  return apiFetch({ endPoint: `PresentType/${presentId}/Recover`, method: 'PUT', presentTypeId: null, token: token })
}
